import { AuthenticationService } from './../../providers/authentication/authentication.service';
import { TipologiaContenidoFormulario, AnchorPoint, TipoLocalizacion } from './../../domain/TipologiaContenidoFormulario';
import { PerfilFormulario } from './../../domain/PerfilFormulario';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ElementRef } from '@angular/core';

import { BreadcrumbService } from '../../breadcrumb.service';

import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { TranslateService } from 'ng2-translate';
import { Message, MenuItem } from 'primeng/primeng';
import { allSettled } from 'q';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { Idioma } from '../../domain/Idioma';
import { Predicate } from 'breeze-client';

import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { Constantes } from '../../domain/constantes';
import { UsuarioFormulario } from '../../domain/UsuarioFormulario';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { Permisos, PermisosService } from '../../providers/authentication/permisos.service';
import { forEach } from '@angular/router/src/utils/collection';
import { TipologiaSeccionFormulario } from './../../domain/TipologiaSeccionFormulario';


@Component({
	templateUrl: './entidades.component.html',
	styleUrls: ['./entidades.component.scss'],
	encapsulation: ViewEncapsulation.None
})

export class EntidadesComponent implements OnInit, OnDestroy {

	@ViewChild('dt_tipologias') dt_tipologias;
	@ViewChild('dt_tipologias_seccion') dt_tipologias_seccion;
	@ViewChild('dt_perfil') dt_perfil;
	@ViewChild('dt_usuarios') dt_usuarios;

	spinner: HTMLElement;
	blockUI: HTMLElement;
	displayDialog: boolean;
	msgs: Message[] = [];

	// Perfiles de Movilidad
	perfilesMovilidad: any[] = [];
	perfilSeleccionado: PerfilFormulario = new PerfilFormulario(); // = {Id: '', Nomobre: '', PesoMAximo: '', ENTIDAD: {}};
	edicion: boolean = false;
	cols_perfil: any[] = [];

	// tipologias contenido
	tipologiaSeleccionada: TipologiaContenidoFormulario; // {Id: '', Nombre: '', Tipo: '', Buscable: false, VisibilidadPorDefecto: true, IconoRepresentacion: '', ENTIDAD: {}};
	tipologiasContenido: any[] = [];
	cols_tipologias: any[] = [];
	nombresTipologias: any[] = [];

	// tipologias seccion
	tipologiaSeccionSeleccionada: TipologiaSeccionFormulario; 
	tipologiasSeccion: any[] = [];
	cols_tipologias_secciones: any[] = [];
	nombresTipologiasSecciones: any[] = [];

	// perfiles de usuario (Permisos)
	usuarioSeleccionado: UsuarioFormulario = new UsuarioFormulario();
	usuarios: any[] = [];
	usuariosFiltrados: any[] = [];
	cols_usuario: any[] = [];
	fechaAlta_DesdeFiltes: Date;
	fechaAlta_HastaFiltes: Date;

	/* ** p-dialog ** */
	public visibleFormularioTipologia = false;
	public visibleFormularioPerfil = false;
	public visibleFormularioUsuario = false;
	public visibleFormularioTipologiaSeccion = false;

	/* ** p-tabMenu ** */
	public tabMenuItems: MenuItem[];
	public activeItem: MenuItem;
	public hidePerfiles = false;
	public hideTipologiaContenido = false;
	public hidePermisosUsuarios = false;
	public hideTipologiaSeccion = false;

	/* ** IDIOMAS ** */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario ;

	/* Filtros Tabla */
	valoresTrueFalse: any;
	valoresPerfilUsuario: any;
	msgs_form_tipologia: any[];
	msgs_form_tipologia_seccion: any[];

	public permisos: Permisos = new Permisos();

	constructor(

		private sws: ServiciosWebServiceProvider,
		private breadcrumbService: BreadcrumbService,
		private entityManager: EntityManagerProvider,
		public idiomaService: IdiomaService,
		public authenticationService: AuthenticationService,
		public translate: TranslateService,
		private permisosService: PermisosService) {
		this.tipologiaSeleccionada = new TipologiaContenidoFormulario(this.translate);
		this.tipologiaSeccionSeleccionada = new TipologiaSeccionFormulario(this.translate);
		this.breadcrumbService.setItems([
			{

				label: this.translate.instant('Entidades.configuracion')}
			]);

		this.tabMenuItems = [
			{
				label: this.translate.instant('Entidades.perfilesmovilidad'),
				icon: 'iticon-tab-perfil-movilidad ',
				command: (event: any) => {
					this.tabPerfilesSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Entidades.tipologiassecciones'),
				icon: 'iticon-tab-seccion',
				command: (event: any) => {
					this.tabTipologiaSeccionSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Entidades.tipologiascontenidos'),
				icon: 'iticon-tab-tipologia-contenido',
				command: (event: any) => {
					this.tabTipologiaContenidoSeleccionada(event);
				}
			},
			{
				label: this.translate.instant('Entidades.permisosUsuarios'),
				icon: 'iticon-tab-settings',
				command: (event: any) => {
					this.tabPermisosUsuariosSeleccionada(event);
				}
			}
		];

		this.cols_tipologias = [
			{ field: 'IconoRepresentacion', header: this.translate.instant('Entidades.icono') },
			{ field: 'Nombre', header: this.translate.instant('Entidades.nombre') },
			{ field: 'Buscable', header: this.translate.instant('Entidades.buscable') },
			{ field: 'VisibleEnMapa', header: this.translate.instant('Entidades.visibleEnMapa') },
			{ field: 'UbicarAnonimos', header: this.translate.instant('Entidades.UbicarAnonimos')},
			{ field: 'PantallaPrincipal', header: this.translate.instant('Entidades.PantallaPrincipal')},
			{ field: 'MostrableEnDirectorioDeContenidos', header: this.translate.instant('Entidades.visibleEnDirectorio') },
			{ field: 'VisibilidadListaCOntenidosSeccion', header: this.translate.instant('Entidades.VisibilidadListaCOntenidosSeccion') },

			{ field: 'VisibilidadIconoMapa', header: this.translate.instant('Entidades.visibleIcono') },
			{ field: 'VisibilidadLabelMapa', header: this.translate.instant('Entidades.visibleLabel') },

			{ field: 'VisibilidadPorDefecto', header: this.translate.instant('Entidades.visibilidad') }

		];

		this.cols_tipologias_secciones = [
			{ field: 'Nombre', header: this.translate.instant('Entidades.nombre') },
			{ field: 'Descripcion', header: this.translate.instant('Entidades.descripcion') },
			{ field: 'IdAlternativo', header: this.translate.instant('Formularios.IdAlternativo') },
			{ field: 'Activa', header: this.translate.instant('Entidades.activa') }




		];

		this.cols_perfil = [
			{ field: 'Nomobre', header: this.translate.instant('Entidades.nombre') }
			// ,{ field: 'PesoMAximo', header: this.translate.instant('Entidades.pesomaximo') }
		];

		this.cols_usuario = [
			{ field: 'Nombre', header: this.translate.instant('Entidades.nombre') },
			{ field: 'Login', header: this.translate.instant('Formularios.Login') },
			{ field: 'FechaAlta', header: this.translate.instant('Formularios.fechaalta') },
			{ field: 'NombreTipo', header: this.translate.instant('Formularios.perfil') },
			{ field: 'Activo', header: this.translate.instant('General.activo') }
		];

		this.valoresTrueFalse = [{label: this.translate.instant('Boolean.true'), value: true}, {label: this.translate.instant('Boolean.false'), value: false}];
		this.valoresPerfilUsuario = [
			{label: 'SUPER ADMINISTRADOR', value: 'SUPER ADMINISTRADOR'},
			{label: 'CIUDADANO', value: 'CIUDADANO'},
			{label: 'GESTOR ESPACIOS', value: 'GESTOR ESPACIOS'},
			{label: 'GESTOR CONTENIDO', value: 'GESTOR CONTENIDO'},
			{label: 'SOLO NOTIFICACIONES', value: 'SOLO NOTIFICACIONES'}
		];


		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		const that = this;
		this.entityManager.getIDIOMA()
		.then(function(idiomasENTIDAD: any ){
			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
			return that.entityManager.getPERFIL();
		})
		.then(function(res){
			console.log('***** PERFILES');
			that.valoresPerfilUsuario = [];

			res.forEach(perfil => {
				const opcion = {label: perfil.Nombre, value: perfil.Nombre};
				that.valoresPerfilUsuario.push(opcion);
				// perfil.Tipo;
				// perfil.Nombre;
			});

			return that.permisosService.obtenerTIPOLOGIA_CONTENIDO(new Predicate('VisibilidadListaContenidosWeb', '==', 1))
		})
		.then((e) => {

			e.forEach(element => {
				const tipologiaFormulario = new TipologiaContenidoFormulario(that.translate, element);
				that.tipologiasContenido.push(tipologiaFormulario);
				let nombreIdTipologia = {nombre: tipologiaFormulario.Nombre, id: tipologiaFormulario.Id }
				that.nombresTipologias.push(nombreIdTipologia)
			});
			return that.permisosService.obtenerTIPOLOGIA_SECCION()
		})
		.then((s) => {

			s.forEach(element => {
				const tipologiaSeccionFormulario = new TipologiaSeccionFormulario(that.translate, element);
				that.tipologiasSeccion.push(tipologiaSeccionFormulario);
				let nombreIdTipologiaSeccion = {nombre: tipologiaSeccionFormulario.Nombre, id: tipologiaSeccionFormulario.Id }
				that.nombresTipologiasSecciones.push(nombreIdTipologiaSeccion)
			});
			return that.tipologiasSeccion;
		});

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
	}


	ngOnInit() {
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		const that = this;
		return that.obtenerPERFIL_MOVILIDAD_CIUDADANO()
		.then(function(){
			return that.obtenerUSUARIOS();
		})
		.then(function(usuarios){
			that.usuariosFiltrados = usuarios;
			that.tabPerfilesSeleccionada(event);
			that.dt_tipologias.reset();
			that.dt_tipologias_seccion.reset();
			that.dt_usuarios.reset();
			that.dt_perfil.reset();
			return true;
		})
		.then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		});
	}

	dt_usuarios_filter($event_target_value, col_field, equals){
	}

	comprobarPermisos() {
		const userId = this.authenticationService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	obtenerPERFIL_MOVILIDAD_CIUDADANO(){
		const that = this;
		const entityManager = that.entityManager;
		const includes = 'IDIOMAS';
		const idEspacio = that.authenticationService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		that.perfilesMovilidad = [];

		return entityManager.getPERFIL_MOVILIDAD_CIUDADANO(predicado, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY PERFILES');
			}
			else {
				console.log('PERFILES CARGADOS CORRECTAMENTE = ' + entidades.length);
				entidades.forEach(perfil => {
					const perfilFormulario = new PerfilFormulario(perfil); // {Id: '', Nomobre: '', PesoMAximo: '', ENTIDAD: {}};
					that.perfilesMovilidad.push(perfilFormulario);
				});
			}
		});
	}

	obtenerUSUARIOS(){
		const that = this;
		const entityManager = that.entityManager;
		const includes = 'ESPACIOS, PERFIL, PERFIL.FUNCIONALIDADES';

		that.usuarios = [];
		const idEspacio = that.authenticationService.getIdEspacio();
		const where = new Predicate('PERFIL.Tipo', '!=', Constantes.CIUDADANO);
		return entityManager.getUSUARIObyIdEspacio(idEspacio, includes, where)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY PERFIL usuario');
				return that.usuarios;
			}
			else {
				console.log('USUARIO CARGADOS CORRECTAMENTE = ' + entidades.length);
				const loginUsuarioActual = that.authenticationService.getLastUser().toLowerCase().normalizar();
				// const usuariosFijos = entidades.filter( x => x.PERFIL.Tipo !== Constantes.CIUDADANO);
				const usuarioActual = entidades.filter( x => x.Login.toLowerCase().normalizar() === loginUsuarioActual)[0];

				if (usuarioActual.PERFIL.Tipo === Constantes.ADMINISTRADOR_ENTIDAD
					|| usuarioActual.PERFIL.Tipo === Constantes.GESTOR_ESPACIOS
					|| usuarioActual.PERFIL.Tipo === Constantes.SUPER_ADMINISTRADOR
				) {
					entidades.forEach(usuario => {
						const usuarioFormulario = new UsuarioFormulario(usuario);
						that.usuarios.push(usuarioFormulario);
					});
				}
				else{
					const usuarioFormulario = new UsuarioFormulario(usuarioActual);
					that.usuarios.push(usuarioFormulario);
				}

				return that.usuarios;
			}
		});
	}

// Selectores Pestañas
	protected ocultarTabs() {
		this.hidePerfiles = true;
		this.hideTipologiaContenido = true;
		this.hidePermisosUsuarios = true;
		this.hideTipologiaSeccion = true;
	}

	tabPerfilesSeleccionada(event){
		this.activeItem = this.tabMenuItems[0];

		this.ocultarTabs();
		this.hidePerfiles = false;
	}

	tabTipologiaSeccionSeleccionada(event){
		this.activeItem = this.tabMenuItems[1];

		this.ocultarTabs();
		this.hideTipologiaSeccion = false;
	}

	tabTipologiaContenidoSeleccionada(event){
		this.activeItem = this.tabMenuItems[2];

		this.ocultarTabs();
		this.hideTipologiaContenido = false;
	}


	tabPermisosUsuariosSeleccionada(event){
		this.activeItem = this.tabMenuItems[3];

		this.ocultarTabs();
		this.hidePermisosUsuarios = false;
	}

// Tabla Perfiles
	onPerfilSelect($event){
		this.visibleFormularioPerfil = true;
		this.perfilSeleccionado.Idiomas = this.idiomaService.getMapPerfilmovilidadIdiomas(this.perfilSeleccionado.ENTIDAD.IDIOMAS);

		this.perfilSeleccionado.Nomobre = this.perfilSeleccionado.ENTIDAD.Nomobre;
		this.perfilSeleccionado.PesoMAximo = this.perfilSeleccionado.ENTIDAD.PesoMAximo;

		this.edicion = true;
	}

	showFormulario(){
		this.perfilSeleccionado = new PerfilFormulario(); // {Id: '', Nomobre: '', PesoMAximo: '', ENTIDAD: {}};
		this.perfilSeleccionado.Idiomas = this.idiomaService.newMapPerfilmovilidadIdiomas(this.idiomas);
		this.visibleFormularioPerfil = true;
		this.edicion = false;
	}

// Tabla tipologias
	onTipologiaSelect($event){
		this.visibleFormularioTipologia = true;
		this.tipologiaSeleccionada.Idiomas = this.idiomaService.getMapTipologiaContenidoIdiomas(this.tipologiaSeleccionada.ENTIDAD.IDIOMAS);

		this.tipologiaSeleccionada.Nombre = this.tipologiaSeleccionada.ENTIDAD.Nombre;
		this.tipologiaSeleccionada.Buscable = this.tipologiaSeleccionada.ENTIDAD.Buscable;
		this.tipologiaSeleccionada.VisibilidadPorDefecto = this.tipologiaSeleccionada.ENTIDAD.VisibilidadPorDefecto;
		this.tipologiaSeleccionada.VisibleEnMapa = this.tipologiaSeleccionada.ENTIDAD.VisibleEnMapa;
		this.tipologiaSeleccionada.UbicarAnonimos = this.tipologiaSeleccionada.ENTIDAD.UbicarAnonimos;
		this.tipologiaSeleccionada.PantallaPrincipal = this.tipologiaSeleccionada.ENTIDAD.PantallaPrincipal;
		this.tipologiaSeleccionada.VisibilidadIconoMapa = this.tipologiaSeleccionada.ENTIDAD.VisibilidadIconoMapa;
		this.tipologiaSeleccionada.VisibilidadLabelMapa = this.tipologiaSeleccionada.ENTIDAD.VisibilidadLabelMapa;
		this.tipologiaSeleccionada.MostrableEnDirectorioDeContenidos = this.tipologiaSeleccionada.ENTIDAD.MostrableEnDirectorioDeContenidos;
		this.tipologiaSeleccionada.IconoRepresentacion = this.tipologiaSeleccionada.ENTIDAD.IconoRepresentacion;
		this.tipologiaSeleccionada.anchorPoint = new AnchorPoint(this.tipologiaSeleccionada.ENTIDAD.AnchorPoint);
		this.tipologiaSeleccionada.TipoUbicacion = new TipoLocalizacion(this.translate, this.tipologiaSeleccionada.ENTIDAD.TipoUbicacion);
		this.tipologiaSeleccionada.Activa = this.tipologiaSeleccionada.ENTIDAD.Activa;

		this.edicion = true;
	}

	// Tabla tipologias
	onTipologiaSeccionSelect($event){
		console.log($event);
		console.log(this.tipologiaSeccionSeleccionada);
		this.visibleFormularioTipologiaSeccion = true;
		this.tipologiaSeccionSeleccionada.Idiomas = this.idiomaService.getMapTipologiaContenidoIdiomas(this.tipologiaSeccionSeleccionada.ENTIDAD.IDIOMAS);

		this.tipologiaSeccionSeleccionada.Nombre = this.tipologiaSeccionSeleccionada.ENTIDAD.Nombre;
		this.tipologiaSeccionSeleccionada.Descripcion = this.tipologiaSeccionSeleccionada.ENTIDAD.Descripcion;
		this.tipologiaSeccionSeleccionada.IdAlternativo = this.tipologiaSeccionSeleccionada.ENTIDAD.IdAlternativo;
		this.tipologiaSeccionSeleccionada.Activa = this.tipologiaSeccionSeleccionada.ENTIDAD.Activa;
		this.tipologiaSeccionSeleccionada.IconoRepresentacion = this.tipologiaSeccionSeleccionada.ENTIDAD.IconoRepresentacion;
		this.tipologiaSeccionSeleccionada.anchorPoint = new AnchorPoint(this.tipologiaSeccionSeleccionada.ENTIDAD.AnchorPoint);
		this.tipologiaSeccionSeleccionada.Tipo = this.tipologiaSeccionSeleccionada.ENTIDAD.Tipo;
		

		this.edicion = true;
	}

	showFormularioTipologia(){
		this.tipologiaSeleccionada = new TipologiaContenidoFormulario(this.translate); // {Id: '', Nombre: '', Tipo: '', Buscable: false, VisibilidadPorDefecto: true, IconoRepresentacion: '', ENTIDAD: {}};
		this.tipologiaSeleccionada.Idiomas = this.idiomaService.newMapTipologiaContenidoIdiomas(this.idiomas);
		this.visibleFormularioTipologia = true;
		this.edicion = false;
		this.msgs_form_tipologia = [];
	}

	showFormularioTipologiaSeccion(){
		this.tipologiaSeccionSeleccionada = new TipologiaSeccionFormulario(this.translate); // {Id: '', Nombre: '', Tipo: '', Buscable: false, VisibilidadPorDefecto: true, IconoRepresentacion: '', ENTIDAD: {}};
		this.tipologiaSeccionSeleccionada.Idiomas = this.idiomaService.newMapTipologiaSeccionIdiomas(this.idiomas);
		this.visibleFormularioTipologiaSeccion = true;
		this.edicion = false;
		this.msgs_form_tipologia_seccion = [];
	}

// Tabla Usuarios
	onUsuarioSelect($event){
		this.visibleFormularioUsuario = true;

		this.usuarioSeleccionado.Nombre = this.usuarioSeleccionado.ENTIDAD.Nombre;
		this.usuarioSeleccionado.Login = this.usuarioSeleccionado.ENTIDAD.Login;
		this.usuarioSeleccionado.Email = this.usuarioSeleccionado.ENTIDAD.Email;
		this.usuarioSeleccionado.Email = this.usuarioSeleccionado.ENTIDAD.Email;

		this.edicion = true;
	}

	showFormularioUsuario(){
		this.usuarioSeleccionado = new UsuarioFormulario();
		this.visibleFormularioUsuario = true;
		this.edicion = false;
	}

	onFechaFilterchanged(event, columna, tipo){

		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			if (columna === 'FechaInstalacion') {
				this.fechaAlta_DesdeFiltes = event;
			}
		}
		if (tipo === 'Hasta') {
			if (columna === 'FechaInstalacion') {
				this.fechaAlta_HastaFiltes = event;
			}
		}

		const that = this;
		this.usuariosFiltrados = this.usuarios;

			// Aplicamos filtro FechaAlta
		this.usuariosFiltrados = this.usuariosFiltrados.filter(function (bal) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.fechaAlta_DesdeFiltes === undefined || that.fechaAlta_DesdeFiltes === null) &&
				(that.fechaAlta_HastaFiltes === undefined || that.fechaAlta_HastaFiltes === null)) {
				return true;
			}
			if (that.fechaAlta_DesdeFiltes !== undefined && that.fechaAlta_DesdeFiltes !== null ) {
				flagDesde = that.fechaAlta_DesdeFiltes < bal.FechaAlta;
			}
			if (that.fechaAlta_HastaFiltes !== undefined && that.fechaAlta_HastaFiltes !== null) {
				flagHasta = that.fechaAlta_HastaFiltes > bal.FechaAlta;
			}
			return flagDesde && flagHasta;
		});
	}


// Formulario Usuario

	onFormularioUsuarioShow(){

	}
	onFormularioUsuarioCerrado($event){
		this.usuarioSeleccionado = new UsuarioFormulario();

	}

	onElementoUsuarioGuardado($event){
		const that = this;
		if ($event) {
			this.usuarios = [];
			this.obtenerUSUARIOS()
			.then(function(usuarios){
				that.spinner.style.display = 'none';
				that.usuariosFiltrados = usuarios;
				that.visibleFormularioUsuario = false;
			});
		}

	}

	onElementoUsuarioEliminado($event){

	}

	onFormularioUsuarioValidation($event){

	}

// Formulario Perfiles
	onFormularioPerfilShow(){

	}

	onElementoPerfilEliminado($event){

	}

	onFormularioValidation($event){

	}

	onFormularioPerfilCerrado(event) {
		this.perfilSeleccionado = new PerfilFormulario();
	}

	onElementoPerfilGuardado(perfilFormulario){
		const that = this;
		if (!this.edicion) {
			this.perfilesMovilidad.push(perfilFormulario);

			this.asignarPesoAConexiones(perfilFormulario)
			.then(function(msg){

				// Ocultamos Spinner
				that.spinner.style.display = 'none';

				that.visibleFormularioPerfil = false;
				console.log('Perfil guardado Correctamente: ' + msg);
			});
		}
		else{
			this.spinner.style.display = 'none';
			this.visibleFormularioPerfil = false;
		}
	}

	public asignarPesoAConexiones(perfilFormulario) {

		// PREPARAMOS LA SUBIDA DE LAS FOTOS
		const that = this;
		const includes = 'CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';
		let nodosTodos;
		const conexiones = [];
		return this.obtenerNODOs()
		.then(function(nodos){

			nodosTodos = nodos;
			nodosTodos.forEach(nodo => {
				nodo.CONEXIONS_NODOS_ORIGEN.forEach(conexion => {
					conexiones.push(conexion);
				});
			});

			return that.crearPesos(conexiones);

		})
		.then(function(pesos){

			if (pesos) {
				for (let index = 0; index < pesos.length; index++) {
					const peso = pesos[index].value;
					const conexion = conexiones[index];
					peso.PerfilMovilidad = perfilFormulario.ENTIDAD;
					peso.ConexionNodo = conexion;
					peso.Peso = Constantes.PESO;
				}
				return that.entityManager.saveChanges();
			}


		});
	}

	crearPesos(conexiones){
		if (conexiones == null || conexiones.length < 1) {
			console.log('NO HAY NODOS');
		}
		else {
			const promises: any[] = [];

			conexiones.forEach(ENTIDAD => {
				promises.push(this.entityManager.newPESO_CONEXION());
			});
			return allSettled(promises);
		}
	}

	obtenerNODOs() {
		const that = this;
		const entityManager = that.entityManager;

		//  const includes = 'SECCIONS, SECCIONS.NODOS, SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO';
		// let includes = 'SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';
		const includes = 'CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';

		return entityManager.getNODO(undefined, includes);
	}

// Formulario Tipologia
	onFormularioTipologiaShow(){
		this.msgs_form_tipologia = [];
	}
	// Formulario Tipologia Sección
	onFormularioTipologiaSeccionShow(){
		this.msgs_form_tipologia_seccion = [];
	}

	onFormularioTipologiaCerrado($event){
		this.tipologiaSeleccionada = new TipologiaContenidoFormulario(this.translate);
		this.visibleFormularioTipologia = false;
		this.idiomaSeleccionado = this.idiomaDefecto;
	}

	onFormularioTipologiaSeccionCerrado($event){
		this.tipologiaSeccionSeleccionada = new TipologiaSeccionFormulario(this.translate);
		this.visibleFormularioTipologiaSeccion = false;

		this.idiomaSeleccionado = this.idiomaDefecto;
	}

	onElementoTipologiaGuardado(tipologiaContenidoFormulario){

		if (!this.edicion) {
			this.tipologiasContenido.push(tipologiaContenidoFormulario);
			let nombreIdTipologia = {nombre: tipologiaContenidoFormulario.Nombre, id: tipologiaContenidoFormulario.Id}
			this.nombresTipologias.push(nombreIdTipologia)
		}

		const idTipologia = tipologiaContenidoFormulario.ENTIDAD.Id;
		const perfil = this.tipologiasContenido.find(x => x.ENTIDAD.Id === idTipologia);
		let nombreIdTipologia = {nombre: tipologiaContenidoFormulario.Nombre, id: tipologiaContenidoFormulario.Id}
		this.nombresTipologias.push(nombreIdTipologia)



		this.visibleFormularioTipologia = false;



		this.spinner.style.display = 'none';
	}

	onElementoTipologiaEliminado($event){
		const that = this;
		if ($event) {
			this.usuarios = [];
			return that.permisosService.obtenerTIPOLOGIA_CONTENIDO(new Predicate('VisibilidadListaContenidosWeb', '==', 1))
			.then((e) => {
				return that.tipologiasContenido = e;
				that.spinner.style.display = 'none';
				that.visibleFormularioTipologia = false;
			});
		}
	}

	onFormularioTipologiaValidation($event){

	}
	onElementoTipologiaSeccionGuardado(tipologiaSeccionFormulario){

		if (!this.edicion) {
			this.tipologiasSeccion.push(tipologiaSeccionFormulario);
			let nombreIdTipologiaSeccion = {nombre: tipologiaSeccionFormulario.Nombre, id: tipologiaSeccionFormulario.Id}
			this.nombresTipologiasSecciones.push(nombreIdTipologiaSeccion)
		}

		const idTipologiaSeccion = tipologiaSeccionFormulario.ENTIDAD.Id;
		const perfil = this.tipologiasSeccion.find(x => x.ENTIDAD.Id === idTipologiaSeccion);
		let nombreIdTipologiaSeccion = {nombre: tipologiaSeccionFormulario.Nombre, id: tipologiaSeccionFormulario.Id}
		this.nombresTipologiasSecciones.push(nombreIdTipologiaSeccion)



		this.visibleFormularioTipologiaSeccion = false;



		this.spinner.style.display = 'none';
	}

	onElementoTipologiaSeccionEliminado($event){
		const that = this;
		if ($event) {
			this.tipologiasSeccion = [];
			return that.permisosService.obtenerTIPOLOGIA_SECCION()
			.then((e) => {
				that.spinner.style.display = 'none';
				that.visibleFormularioTipologiaSeccion = false;
				return that.tipologiasSeccion = e;

			});
		}
	}

	onFormularioTipologiaSeccionValidation($event){

	}

	downloadFile(fileName) {
		if (fileName === 'Guia_de_Refencia_de_estilos.pdf') {
			return this.sws.downloadFile(Constantes.Guia_de_Refencia_de_estilos_tipotolia, fileName);
		}
		if (fileName === 'tipologia-plantilla.svg') {
			return this.sws.downloadFile(Constantes.Tipologia_Plantilla, fileName);
		}
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Entidades/entidades.component.ts